// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banibon_banibon__UUwhW {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh);
}

.banibon_inner__CYsbq {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
  width: 100%;
  padding: 0 16px;
}

.banibon_items__gwP\\+m {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  height: calc(100vh - 350px);
  overflow: hidden;
  overflow-y: auto;
  justify-content: flex-start;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  border-top: 2px solid rgba(255, 255, 255, 0.1);
  padding: 13px 6px;
}

.banibon_itemsInner__q7Xqq {
  display: flex;
  flex-flow: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.banibon_empty__1nc8n {
  /* min-height: calc(100vh - 220px); */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 24px;
  max-width: 500px;
}

.banibon_empty-top__HIyPX {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.banibon_empty-title__d2GZk {
  color: rgba(255, 255, 255, 0.5);
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.banibon_empty-desc__yb0uC {
  margin-top: 7px;
  color: #fff;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.banibon_empty-hero__FmN9M {
  margin-top: 40px;
  min-width: 328px;
  min-height: 266px;
}

.banibon_empty-bottom__vFqXM {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.banibon_wrapper__SXVhd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.banibon_tabs__vqoFJ {
  border-radius: 24px;
  background: #507687;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px;
  /* margin-bottom: 26px; */
  transition: all 0.2s ease-in-out;
  margin-top: 24px;
}

.banibon_tab__rjsdn {
  color: #fcfaee;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 36px;
  padding: 0 30px;
  border-radius: 47px;
  transition: all 0.2s ease-in-out;
  width: 172px;
}

.banibon_tab-active__3SpW2 {
  background: #fff;
  color: #384b70;
  font-weight: 600;
}

.banibon_row__FNoIo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.banibon_banicoinCard__SxF9F {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.banibon_normalCard__7ACIU {
}

@media screen and (min-width: 1200px) {
  .banibon_banicoinCard__SxF9F {
    width: 32%;
  }

  .banibon_normalCard__7ACIU {
    width: 32%;
  }

  .banibon_items__gwP\\+m {
    max-width: 1200px;
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .banibon_itemsInner__q7Xqq {
    display: flex;
    flex-flow: wrap;
    align-items: center;
    gap: 16px;
    width: 100%;
  }

  .banibon_card__wsis\\+ {
    width: 32%;
  }

  .banibon_placeholder__\\+s4cG {
    width: 17rem !important;
  }

  .banibon_banibon__UUwhW {
    justify-content: space-between;
  }

  .banibon_empty__1nc8n {
    max-width: 1200px;
    width: 100%;
  }

  .banibon_empty-hero__FmN9M {
    width: 500px;
    min-height: 405px;
  }

  .banibon_empty-bottom__vFqXM {
    max-width: 500px;
  }

  .banibon_empty-title__d2GZk {
    font-size: 16px;
  }

  .banibon_empty-desc__yb0uC {
    font-size: 18px;
  }
}

.banibon_normalBadge__Cdqa7 {
  width: 94% !important;
  z-index: 1 !important;
}

.banibon_bagdeInnerNoraml__Eb24U {
  border-radius: 16px 16px !important;
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.banibon_bagdeTitle__PAWSb {
  justify-content: right;
}
`, "",{"version":3,"sources":["webpack://./src/pages/banibons/banibon.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,iDAAiD;EACjD,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;AACA;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".banibon {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  min-height: calc(100vh - 60px);\n  min-height: calc(100dvh);\n}\n\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 30px;\n  width: 100%;\n  padding: 0 16px;\n}\n\n.items {\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  height: calc(100vh - 350px);\n  overflow: hidden;\n  overflow-y: auto;\n  justify-content: flex-start;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  border-top: 2px solid rgba(255, 255, 255, 0.1);\n  padding: 13px 6px;\n}\n\n.itemsInner {\n  display: flex;\n  flex-flow: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.empty {\n  /* min-height: calc(100vh - 220px); */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-top: 24px;\n  max-width: 500px;\n}\n\n.empty-top {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.empty-title {\n  color: rgba(255, 255, 255, 0.5);\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.empty-desc {\n  margin-top: 7px;\n  color: #fff;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.empty-hero {\n  margin-top: 40px;\n  min-width: 328px;\n  min-height: 266px;\n}\n\n.empty-bottom {\n  margin-top: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.tabs {\n  border-radius: 24px;\n  background: #507687;\n  overflow: hidden;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2px;\n  /* margin-bottom: 26px; */\n  transition: all 0.2s ease-in-out;\n  margin-top: 24px;\n}\n\n.tab {\n  color: #fcfaee;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  height: 36px;\n  padding: 0 30px;\n  border-radius: 47px;\n  transition: all 0.2s ease-in-out;\n  width: 172px;\n}\n\n.tab-active {\n  background: #fff;\n  color: #384b70;\n  font-weight: 600;\n}\n\n.row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.banicoinCard {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.normalCard {\n}\n\n@media screen and (min-width: 1200px) {\n  .banicoinCard {\n    width: 32%;\n  }\n\n  .normalCard {\n    width: 32%;\n  }\n\n  .items {\n    max-width: 1200px;\n    width: 100%;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n\n  .itemsInner {\n    display: flex;\n    flex-flow: wrap;\n    align-items: center;\n    gap: 16px;\n    width: 100%;\n  }\n\n  .card {\n    width: 32%;\n  }\n\n  .placeholder {\n    width: 17rem !important;\n  }\n\n  .banibon {\n    justify-content: space-between;\n  }\n\n  .empty {\n    max-width: 1200px;\n    width: 100%;\n  }\n\n  .empty-hero {\n    width: 500px;\n    min-height: 405px;\n  }\n\n  .empty-bottom {\n    max-width: 500px;\n  }\n\n  .empty-title {\n    font-size: 16px;\n  }\n\n  .empty-desc {\n    font-size: 18px;\n  }\n}\n\n.normalBadge {\n  width: 94% !important;\n  z-index: 1 !important;\n}\n\n.bagdeInnerNoraml {\n  border-radius: 16px 16px !important;\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n\n.bagdeTitle {\n  justify-content: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banibon": `banibon_banibon__UUwhW`,
	"inner": `banibon_inner__CYsbq`,
	"items": `banibon_items__gwP+m`,
	"itemsInner": `banibon_itemsInner__q7Xqq`,
	"empty": `banibon_empty__1nc8n`,
	"empty-top": `banibon_empty-top__HIyPX`,
	"empty-title": `banibon_empty-title__d2GZk`,
	"empty-desc": `banibon_empty-desc__yb0uC`,
	"empty-hero": `banibon_empty-hero__FmN9M`,
	"empty-bottom": `banibon_empty-bottom__vFqXM`,
	"wrapper": `banibon_wrapper__SXVhd`,
	"tabs": `banibon_tabs__vqoFJ`,
	"tab": `banibon_tab__rjsdn`,
	"tab-active": `banibon_tab-active__3SpW2`,
	"row": `banibon_row__FNoIo`,
	"banicoinCard": `banibon_banicoinCard__SxF9F`,
	"normalCard": `banibon_normalCard__7ACIU`,
	"card": `banibon_card__wsis+`,
	"placeholder": `banibon_placeholder__+s4cG`,
	"normalBadge": `banibon_normalBadge__Cdqa7`,
	"bagdeInnerNoraml": `banibon_bagdeInnerNoraml__Eb24U`,
	"bagdeTitle": `banibon_bagdeTitle__PAWSb`
};
export default ___CSS_LOADER_EXPORT___;
